import { Injectable } from '@angular/core';
import { CanDeactivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ContinueEditingService } from '../services/continue-editing.service';
import { CloseDialogResult } from '../models/dialog/continue-editing-dialog.model';

@Injectable({ providedIn: 'root' })
export class ContinueEditingGuard implements CanDeactivate<unknown> {
  constructor(private continueEditingService: ContinueEditingService, private router: Router) {}

  async canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Promise<boolean> {
    const fromPath = this.router.url || currentState.url || '';
    const mainPath = '/' + (fromPath.split('/')[1] || '');
    const toUrl = nextState?.url ?? '';
    const finalToUrl = this.router.getCurrentNavigation()?.finalUrl?.toString() ?? toUrl;

    if (!finalToUrl) {
      return true;
    }

    const openDialog: CloseDialogResult = await this.continueEditingService.openContinueEditingDialog(mainPath, finalToUrl);

    let result = true;
    if (openDialog === CloseDialogResult.continueEditing) {
      result = false;
    }
    return result;
  }
}
